/* Vanashree Organics - mobile tap-to-reveal Quick View icon on product cards.
On touch devices the .vo-qv-btn eye icon is hidden by default (see
organicbazar-font-overrides.css) so it doesn't clutter every card. First tap
on a card's image reveals the icon (adds .vo-touched) instead of navigating
straight to the product; a second tap on the image (or a tap on the now-
visible icon) proceeds normally. Tapping anywhere else hides it again.
Desktop hover is unaffected. */
(function () {
  'use strict';
  var d = document;

  d.addEventListener('click', function (e) {
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (canHover) return;

    var qvBtn = e.target.closest && e.target.closest('.vo-qv-btn');
    if (qvBtn) return;

    var link = e.target.closest && e.target.closest('.vo-card__image-wrap');
    if (!link) {
      var open = d.querySelector('.vo-card__media.vo-touched');
      if (open) open.classList.remove('vo-touched');
      return;
    }

    var media = link.closest('.vo-card__media');
    if (!media) return;

    if (!media.classList.contains('vo-touched')) {
      e.preventDefault();
      var already = d.querySelector('.vo-card__media.vo-touched');
      if (already && already !== media) already.classList.remove('vo-touched');
      media.classList.add('vo-touched');
    }
  }, true);
})();
